import { useUniqId } from '../../libs/uniq-id';
export function useRadioGroupState(props) {
    var disabled = props.disabled, readOnly = props.readOnly, name = props.name, value = props.value, onChange = props.onChange;
    var groupName = useUniqId(name);
    return {
        isDisabled: disabled,
        name: groupName,
        isReadOnly: readOnly,
        selectedValue: value,
        setSelectedValue: onChange,
    };
}
